import { IconSize } from '@constants';
import { ChevronDownIcon } from '@heroicons/react/24/outline';
import { InputAdornment, useTheme } from '@mui/material';

const ChevronDownAdornment = () => {
  const theme = useTheme();
  return (
    <InputAdornment position="end">
      <ChevronDownIcon color={theme.palette.dark.dark_3} width={IconSize.sm} />
    </InputAdornment>
  );
};

export default ChevronDownAdornment;
